export default "__VITE_ASSET__CogPgpzB__"